import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';
import { PharmOrder } from 'src/app/core/models';
import { ResponsiveUtilsService } from '../../core/services';
import { FormatDatePipe } from 'src/app/core/utils/pipes';
@Component({
  selector: 'app-pharm-orders-list',
  templateUrl: './pharm-orders.component.html',
  styleUrls: ['./pharm-orders.component.scss'],
})
export class PharmOrdersComponent {
  @Input() pharmOrders: PharmOrder[] = [];
  @Input() emptyMessageTitle: string = '';
  @Input() emptyMessage: string = '';
  @Input() hasLoadMore: boolean = false;
  @Input() loadMorePharmOrders: () => void = () => {};
  @Input() isLoadingMorePharmOrders: boolean = false;

  isTouchDevice$ = this.responsiveUtils.isTouchDevice();
  isBelowXl$ = this.responsiveUtils.isBelowXl();
  isBelowPrime$ = this.responsiveUtils.isBelowPrime();
  formatDatePipe = new FormatDatePipe();

  constructor(private router: Router, private responsiveUtils: ResponsiveUtilsService) {}

  goToTrackOrder(trackingUrl: string) {
    window.open(trackingUrl, '_blank');
  }

  goToAuthorizeOrder(enterpriseOrderId: string) {
    this.router.navigate(['/authorization', enterpriseOrderId, 'authorize']);
  }
}
